<template>
  <div id="app">
    <!--Login-->
    <div id="wrapper" v-show="!user.uid">
      <div id="page-content" class="full-width">
        <div class="container">
          <div class="row">
            <div class="offset-md-4 col-md-4">
              <div class="page-brand">
                <img src="./assets/img/UNITLogo.png" height="105px" width="105px"/>
              </div>
              <div id="firebaseui-auth-container"></div>
              <br>
              <p style="color:red;text-align:center;">{{user.failedLogin}}</p>
              <p style="font-size:11px;line-height:1.4;text-align:justify;color:#666;margin-top:15px;">This computer system, including all related equipment, networks, and devices (specifically including internet access), are provided only to customers ("Customers") of UNIT Innovations (the "Company") for use by each Customer's users. By signing in or using this system, you acknowledge and agree to the terms of that certain Software as a Service (SaaS) License Agreement (the "Agreement") with the Company, a copy of which is available at https://www.unitinnovations.com/terms. By continuing to use this system, you indicate your awareness of and consent to the Agreement and are indicating your agreement to be bound by the terms of the Agreement.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /#wrapper -->

    <!--App-->
    <div id="wrapper" v-show="user.uid">
      <nav class="navbar navbar-spark navbar-toggleable">
        <div class="container-fluid">
          <button type="button" v-on:click="mobileSidebarShowing = true" class="sidebar-open hidden-md-up">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand hidden-sm-down" href="index.html">
            <img src="./assets/img/UNITLogo.png" height="80px" width="80px"/>
          </a>
          <ul class="nav navbar-nav navbar-right">
            <li class="nav-item dropdown">
              <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Profile</a>
              <ul class="dropdown-menu">
                <li><router-link class="dropdown-item" to="/profile"><i class="ion ion-person"></i> View Profile</router-link></li>
                <li role="separator" class="dropdown-divider"></li>
                <li><a class="dropdown-item" target="_blank" href="http://premises.support.unitdynamic.com"><i class="ion ion-help"></i> Support Desk</a></li>
                <li role="separator" class="dropdown-divider"></li>
                <li><a class="dropdown-item" href="#" v-on:click="logout"><i class="ion ion-log-out"></i> Sign out</a></li>
              </ul>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link">Org: {{this.$store.state.usermain.curOrg.name}}</a>
            </li>
          </ul>
        </div>
      </nav>

      <div id="content">
        <header id="page-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-8 page-title-wrapper">
                <h1 class="page-title">UNIT</h1>
                <h2 class="page-subtitle">{{currentRoute}}</h2>
              </div>
              <!--<div class="col-sm-4 hidden-sm-down page-search-wrapper">
                <input type="text" class="form-control form-control-lg keyword-search" placeholder="Search...">
              </div>-->
            </div>
          </div>
        </header>
        <div id="page-body">
          <div class="container-fluid">
            <div id="page-sidebar" :class="{'sidebar':true, 'toggled': mobileSidebarShowing == true ? false : true}">
              <nav class="sidebar-collapse hidden-sm-down">
                <!--<i class="ion ion-ios-arrow-forward show-on-collapsed"></i>
                <i class="ion ion-ios-arrow-back hide-on-collapsed"></i>-->
              </nav>

              <ul class="nav nav-pills nav-stacked flex-column" id="sidebar-stacked">
                <li class="hidden-md-up">
                  <a href="#" class="sidebar-close" v-on:click="mobileSidebarShowing = false"><i class="ion ion-ios-arrow-back"></i></a>
                </li>
                <router-link tag="li" class = "nav-item" exact-active-class="active" to="/">
                  <a class = "nav-link"><i class="ion ion-ios-home"></i> <span class="nav-text">Home</span></a>
                </router-link>
                <li class="nav-item" :class="{'active': subIsActive('/operations')}">
                  <a class="nav-container dropdown-toggle" data-toggle="collapse" data-parent="#sidebar-stacked" href="#p2">
                    <i class="ion ion-ios-clipboard"></i> <span class="nav-text">Operations</span>
                  </a>
                  <ul class="nav nav-pills nav-stacked flex-column collapse" id="p2">
                    <router-link tag="li" class = "nav-item" active-class="active" to="/operations/workflows">
                      <a class = "nav-link">Workflows</a>
                    </router-link>
                    <router-link tag="li" class = "nav-item" active-class="active" to="/operations/archivedworkflows" v-if="org['curOrg']['role'] == 99" >
                      <a class = "nav-link">Archived Workflows</a>
                    </router-link>
                    <!--<router-link tag="li" class = "nav-item" exact-active-class="active" to="/operations/alertsnotifications">
                      <a class = "nav-link">Notifications</a>
                    </router-link>-->
                    <!-- <router-link tag="li" class = "nav-item" exact-active-class="active" to="/operations/inventory">
                      <a class = "nav-link">Inventory</a>
                    </router-link> -->
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/operations/wire">
                      <a class = "nav-link">Wire</a>
                    </router-link>
                  </ul>
                </li>
                <li class="nav-item" v-if="org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99" :class="{'active': subIsActive('/insights')}">
                  <a class="nav-container dropdown-toggle" data-toggle="collapse" data-parent="#sidebar-stacked" href="#p3">
                    <i class="ion ion-ios-stats"></i> <span class="nav-text">Insights</span>
                  </a>
                  <ul class="nav nav-pills nav-stacked flex-column collapse" id="p3">
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/insights/datavisualization">
                      <a class = "nav-link">Data Visualization</a>
                    </router-link>
                  </ul>
                </li>
                <li class="nav-item" v-if="org['curOrg']['role'] == 99" :class="{'active': subIsActive('/inventory')}">
                  <a class="nav-container dropdown-toggle" data-toggle="collapse" data-parent="#sidebar-stacked" href="#p4">
                    <i class="ion ion-ios-list-box"></i> <span class="nav-text">Inventory</span>
                  </a>
                  <ul class="nav nav-pills nav-stacked flex-column collapse" id="p4">
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/inventory/assets">
                      <a class = "nav-link">Assets</a>
                    </router-link>
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/inventory/groups">
                      <a class = "nav-link">Groups</a>
                    </router-link>
                    <!--<router-link tag="li" class = "nav-item" exact-active-class="active" to="">
                      <a class = "nav-link">Incidents</a>
                    </router-link>
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="">
                      <a class = "nav-link">Lifecycle</a>
                    </router-link> -->
                  </ul>
                </li>
                <li class="nav-item" v-if="org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99" :class="{'active': subIsActive('/admin')}">
                  <a class="nav-container dropdown-toggle" data-toggle="collapse" data-parent="#sidebar-stacked" href="#p5">
                    <i class="ion ion-ios-settings"></i> <span class="nav-text">Management</span>
                  </a>
                  <ul class="nav nav-pills nav-stacked flex-column collapse" id="p5">
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/admin/users">
                      <a class = "nav-link">Users</a>
                    </router-link>
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/admin/devices">
                      <a class = "nav-link">Devices</a>
                    </router-link>
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/admin/workflowattributes">
                      <a class = "nav-link">Workflow Attributes</a>
                    </router-link>
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/admin/workflowgroups">
                      <a class = "nav-link">Workflow Groups</a>
                    </router-link>
                  </ul>
                </li>
                <li class="nav-item" v-if="org['curOrg']['role'] == 99" :class="{'active': subIsActive('/stanadmin')}">
                  <a class="nav-container dropdown-toggle" data-toggle="collapse" data-parent="#sidebar-stacked" href="#p6">
                    <i class="ion ion-ios-cog"></i> <span class="nav-text">Stan Admin</span>
                  </a>
                  <ul class="nav nav-pills nav-stacked flex-column collapse" id="p6">
                    <router-link tag="li" class = "nav-item" exact-active-class="active" to="/stanadmin/organizations">
                      <a class = "nav-link">Organizations</a>
                    </router-link>
                  </ul>
                </li>
              </ul>
            </div>
            <div id="page-content">
              <router-view></router-view>

              <footer id="footer" class="text-center">
                <p>&copy; {{moment().format('YYYY')}} UNIT Portal</p>
                <ul class="list-inline">
                  <li class="list-inline-item"><a href="http://premises.support.unitdynamic.com">Support</a></li>
                  <li class="list-inline-item"><a href="mailto:support@unitinnovations.com">Contact</a></li>
                </ul>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- /#wrapper -->
  </div>
</template>

<script>window.__theme = 'bs4';</script>
<script>
import auth from './components/webmaster/Authentication/auth'
import firebase from 'firebase'
import store from './components/webmaster/Store/vuex'

import '../node_modules/bootstrap/js/src/dropdown.js';
import bootstrap from 'bootstrap';

const user = auth.getUser()

export default {
  name: 'app',
  data() {
    return {
      currentRoute: this.$route.name,
      mobileSidebarShowing: false,
      org: store.state.usermain,
      user,
    }
  },
  watch: {
    '$route' (){
      //Update Title Bar on Each Page Change
      this.currentRoute = this.$route.name;
      this.mobileSidebarShowing = false;
    }
  },
  methods: {
    logout: function(){
      this.$store.commit('reset');
      auth.logout();
    },
    subIsActive: function(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0 // current path starts with this path string
      })
    }
  },
  created: function(){
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?0712b2d3